var render, staticRenderFns
import script from "./PillStyle.vue?vue&type=script&lang=js&"
export * from "./PillStyle.vue?vue&type=script&lang=js&"
import style0 from "./PillStyle.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./PillStyle.vue?vue&type=style&index=1&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports